
import React from "react";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import AnalysisTabs from "./AnalysisTabs";

interface AnalysisResultsProps {
  analysisResult: any;
  onDownloadReport: () => void;
}

const AnalysisResults: React.FC<AnalysisResultsProps> = ({ 
  analysisResult,
  onDownloadReport 
}) => {
  if (!analysisResult) return null;

  return (
    <div className="border rounded-lg p-4 mt-4">
      <div className="flex justify-between items-center mb-4">
        <h4 className="font-semibold text-lg">Analysis Results</h4>
        <Button variant="outline" size="sm" onClick={onDownloadReport}>
          <FileDown className="h-4 w-4 mr-2" />
          Download PDF Report
        </Button>
      </div>
      
      <AnalysisTabs analysisResult={analysisResult} />
    </div>
  );
};

export default AnalysisResults;
